module.exports = __webpack_public_path__ + "images/checkbox/checkbox_field_ordering_admin.png";